function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Link } from "react-router-dom";
import { api, num, isNotEnabled, errText } from "./api";
export const OUTREACH_SETTINGS_PATH = "/Email/senders/outreach";

/**
 * Email settings → "Outreach mailboxes": a one-line summary of the workspace's outreach domains and mailboxes, with
 * the full management page (register a domain, DNS recheck, start warmup, pause, disable, the domains table) one click
 * away under Manage. Per workspace, so any tenant with Outreach sets up its own there.
 */
class OutreachSettingsCard extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      infra: null,
      error: null,
      off: false
    });
  }
  componentDidMount() {
    this._alive = true;
    api("GET", "/infrastructure").then(infra => this._alive && this.setState({
      infra
    })).catch(e => this._alive && this.setState(isNotEnabled(e) ? {
      off: true
    } : {
      error: errText(e, "Outreach mailboxes could not be loaded.")
    }));
  }
  componentWillUnmount() {
    this._alive = false;
  }
  summary() {
    const {
      infra,
      error
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement("span", {
      className: "ems-sub bad"
    }, error);
    if (infra === null) return /*#__PURE__*/React.createElement("span", {
      className: "ems-sub"
    }, "Loading\u2026");
    const domains = infra.domains || [];
    const boxes = infra.mailboxes || [];
    if (!domains.length) return /*#__PURE__*/React.createElement("span", {
      className: "ems-sub"
    }, "No mailboxes yet. Add a sending domain and its mailboxes before your first outreach campaign.");
    const count = s => boxes.filter(m => m.status === s).length;
    const warming = count("warming"),
      paused = count("paused"),
      notStarted = count("provisioning");
    const parts = [`${num(boxes.length)} mailbox${boxes.length === 1 ? "" : "es"} on ${num(domains.length)} domain${domains.length === 1 ? "" : "s"}`];
    if (warming) parts.push(`${num(warming)} warming up`);
    if (notStarted) parts.push(`${num(notStarted)} not started`);
    if (paused) parts.push(`${num(paused)} paused`);
    return /*#__PURE__*/React.createElement("span", {
      className: "ems-sub"
    }, parts.join(" · "));
  }
  render() {
    if (this.state.off) return null;
    return /*#__PURE__*/React.createElement("section", {
      className: "ems-card ems-compact"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ems-title"
    }, /*#__PURE__*/React.createElement("b", null, "Outreach mailboxes"), this.summary()), /*#__PURE__*/React.createElement(Link, {
      className: "ems-btn",
      to: OUTREACH_SETTINGS_PATH
    }, "Manage"));
  }
}
export default OutreachSettingsCard;